"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const resources_1 = require("../../resources");
const hooks_1 = require("../../shared/hooks");
const colors_1 = require("../../shared/constants/colors");
const bannerColorsMap = {
    info: colors_1.colors.blueBase,
    alert: colors_1.colors.pinkBase,
    warning: colors_1.colors.greenBase
};
const bannerIconConfig = {
    info: {
        color: "blue",
        icon: ["fas", "info-circle"]
    },
    alert: {
        color: "pink-white",
        icon: ["fas", "exclamation-triangle"]
    },
    warning: {
        color: "green-white",
        icon: ["fas", "exclamation-circle"]
    }
};
const setIcon = (variant) => bannerIconConfig[variant];
const Banner = ({ content, variant = "warning" }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const { icon } = setIcon(variant);
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { variant: variant, children: [(0, jsx_runtime_1.jsx)("div", {}, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: icon, color: "grey", size: isMobile ? "1x" : "lg" }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: content }, void 0), (0, jsx_runtime_1.jsx)(resources_1.LogoPBPSquare, {}, void 0)] }, void 0)] }, void 0));
};
exports.Banner = Banner;
const Wrapper = styled_components_1.default.div `
  display: flex;
  width: 100%;

  & > div:first-of-type {
    background-color: ${({ theme }) => theme.colors.greyBase};
    border-bottom-left-radius: ${({ theme }) => theme.utils.radius};
    border-top-left-radius: ${({ theme }) => theme.utils.radius};
    width: 0.5rem;
  }

  & > div:last-of-type {
    align-items: flex-start;
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border: 1px solid ${({ theme }) => theme.colors.silverBase};
    border-left: none;
    border-bottom-right-radius: ${({ theme }) => theme.utils.radius};
    border-top-right-radius: ${({ theme }) => theme.utils.radius};
    display: flex;
    flex: 1;
    line-height: 1.5rem;
    padding: ${({ theme }) => `${theme.spacings.s} ${theme.spacings.m} ${theme.spacings.s} ${theme.spacings.xl}`};

    p {
      color: ${({ theme }) => theme.colors.greyBase};
      line-height: 1.5rem;
      flex: 1;
      margin-bottom: 0;

      & a:link,
      & a:visited,
      & a:hover {
        color: inherit;
      }

      & a:before {
        content: "";
        padding-left: 2px;
        text-decoration: none;
      }
    }

    & > div:first-of-type {
      padding-right: ${({ theme }) => theme.spacings.m};
    }

    img {
      height: auto;
      margin: ${({ theme }) => `0 ${theme.spacings.xs}`};
      width: 1.5rem;
    }

    a {
      font-weight: 500;
    }

    button {
      background-color: transparent;
      border: none;
      cursor: pointer;
      font-weight: 500;
      padding: 0;
      text-decoration: underline;
    }

    button:focus {
      outline: none;
    }
  }
`;
//# sourceMappingURL=index.js.map